<app-helper-row *ngFor="let row of subsectionData.ListRows;"
    [row]="row" [controller]="controller" [mobile]="mobile">
</app-helper-row>
